import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

type EditableFieldRowProps = {
    label: string;
    value: string;
    isEditing: boolean;
    inputType?: 'text' | 'number';
    placeholder: string;
    error: string;
    onChange: (value: string) => void;
    onEdit: () => void;
    onSave: () => void;
    onFocus?: () => void;
};

const getDisplayValue = (value?: string) =>
    value && value.trim().length ? value : '-';

function EditableFieldRow({
    label,
    value,
    isEditing,
    inputType = 'text',
    placeholder,
    error,
    onChange,
    onEdit,
    onSave,
    onFocus,
}: EditableFieldRowProps) {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSave();
        }
    };

    return (
        <Styles.EditableRow>
            <Styles.EditableRowContent>
                <Styles.CardRowLabel>{`${label}:`}</Styles.CardRowLabel>
                <Styles.EditableRowMiddle>
                    {isEditing ? (
                        <Styles.UnderlineInput
                            name={label}
                            type={inputType}
                            value={value}
                            placeholder={placeholder}
                            onChange={(e) => onChange(e.target.value)}
                            onFocus={onFocus}
                            onKeyDown={handleKeyDown}
                            autoFocus
                        />
                    ) : (
                        <Styles.EditableRowValueText>
                            {getDisplayValue(value)}
                        </Styles.EditableRowValueText>
                    )}
                </Styles.EditableRowMiddle>
                <Styles.RowActions>
                    {isEditing ? (
                        <Styles.ActionIcon>
                            <Image
                                width={20}
                                height={20}
                                alt={`Save ${label}`}
                                src={getImageBasePath(
                                    '/icons/greenTickFill.svg'
                                )}
                                onClick={onSave}
                            />
                        </Styles.ActionIcon>
                    ) : (
                        <Styles.ActionIcon>
                            <Image
                                width={20}
                                height={20}
                                alt={`Edit ${label}`}
                                src={getImageBasePath('/icons/blueEdit.svg')}
                                onClick={onEdit}
                            />
                        </Styles.ActionIcon>
                    )}
                </Styles.RowActions>
            </Styles.EditableRowContent>
            {error.length > 0 && <Styles.FieldError>{error}</Styles.FieldError>}
        </Styles.EditableRow>
    );
}

export default EditableFieldRow;
